import {Component, Inject, OnInit} from "@angular/core";
import {IQuestionModel, KeyValuePair} from "../company-survey-dialog/company-survey-dialog.component";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {CreateUpdateMeetingDto} from "../../../../portal/meeting-api/models/create-update-meeting-dto";
import {ContactPageRequestDto} from "../../../../portal/search-api/models/contact-page-request-dto";
import {GlobalSearchResultTypeEnum} from "../../../../portal/search-api/models/global-search-result-type-enum";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ContactService} from "../../../../portal/search-api/services/contact.service";

import {Store} from "@ngrx/store";
import {IStore} from "../../../../storage/store";
export interface IMeetingModel{
  companyId:string,
  questions:IQuestionModel[]
}

@Component({
  selector: 'meeting-dialog',
  templateUrl: './meeting-dialog.component.html',
  styleUrls: ['./meeting-dialog.component.scss']
})


export class MeetingDialogComponent implements OnInit {
  formGroup1: FormGroup;

  isVisibleCustom1:boolean;
  isVisibleCustom2:boolean;
  isVisibleCustom3:boolean;

  companyId:string;
  companyName:string;

  contacts:KeyValuePair[]=[];
  selectedContact:KeyValuePair[]=[];

  meetingDto:CreateUpdateMeetingDto;

  meetingType:string;


  constructor(private formBuilder: FormBuilder,
              private contactService:ContactService,
              private store: Store<IStore>,
              public dialogRef: MatDialogRef<MeetingDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data) {

    this.meetingType = data.meetingType;

    if(this.meetingType == 'company'){
      this.companyId = data.companyId;
      this.companyName = data.companyName;
    }else{
      this.companyId = data.companyId;
      this.companyName = data.companyName;
      this.selectedContact.push({key:data.contactId,value:data.contactName})
      this.setDataIfPerson();
    }

  }

  meetingModel:IMeetingModel = {
    companyId: '',
    questions: [
      {
        title: 'What are you trying to get?',
        elementName: 'radioGroup1',
        elementValue: ['A warm Introduction', ' Face to face meeting', 'A demo booked', 'Question Answered', 'Other (describe)'],
        elementCustomSpecify: '',
        elementSelectedValue: []
      },
      {
        title: 'With which department?',
        elementName: 'radioGroup2',
        elementValue: ['Marketing', 'Sales', 'Product', 'Engineering', 'Design', 'Finance', 'Customer Success', 'CEO', 'Other (describe)'],
        elementCustomSpecify: '',
        elementSelectedValue: []
      },
      {
        title: 'With whom?',
        elementName: 'radioGroup3',
        elementValue: ['Manager', 'Director', 'Vice President+', 'Anyone', 'Specific Person (enter name)'],
        elementCustomSpecify: '',
        elementSelectedValue: []
      }
    ]
  }

  ngOnInit(): void {

    this.formGroup1 = this.formBuilder.group({
      radioGroup1: [this.findQuestions('radioGroup1').elementSelectedValue[0], Validators.required],
    });
    this.formGroup1.get('radioGroup1').valueChanges.subscribe(data=> {
      this.findQuestions('radioGroup1').elementSelectedValue=[]
      this.findQuestions('radioGroup1').elementSelectedValue.push(data)
    });

    if(this.meetingType=='company'){
      this.formGroup1.addControl("radioGroup2", new FormControl(this.findQuestions('radioGroup2').elementSelectedValue[0], Validators.required));
      this.formGroup1.addControl("radioGroup3", new FormControl(this.findQuestions('radioGroup3').elementSelectedValue[0], Validators.required));

      this.formGroup1.get('radioGroup2').valueChanges.subscribe(data=> {
        this.findQuestions('radioGroup2').elementSelectedValue=[];
        this.findQuestions('radioGroup2').elementSelectedValue.push(data)
      });
      this.formGroup1.get('radioGroup3').valueChanges.subscribe(data=> {
        this.findQuestions('radioGroup3').elementSelectedValue=[];
        this.findQuestions('radioGroup3').elementSelectedValue.push(data);
      });
    }

  }

  public findQuestions(elementName:string){
    return this.meetingModel.questions.find(x=>x.elementName == elementName)
  }

  public onRadioGroup1ItemChange(value) {
    if (value == "Other (describe)") {
      this.formGroup1.addControl("custom1", new FormControl('',Validators.required));
      this.formGroup1.get('custom1').valueChanges.subscribe(data=> this.findQuestions('radioGroup1').elementCustomSpecify = data);
      this.isVisibleCustom1 = true;
    }
    else{
      this.formGroup1.removeControl('custom1');
      this.isVisibleCustom1 = false;
    }
  }
  public onRadioGroup2ItemChange(value) {
    if (value == "Other (describe)") {
      this.formGroup1.addControl("custom2", new FormControl('',Validators.required));
      this.formGroup1.get('custom2').valueChanges.subscribe(data=> this.findQuestions('radioGroup2').elementCustomSpecify = data);
      this.isVisibleCustom2 = true;
    }
    else{
      this.formGroup1.removeControl('custom2');
      this.isVisibleCustom2 = false;
    }
  }
  public onRadioGroup3ItemChange(value) {
    if (value == "Specific Person (enter name)") {
      this.formGroup1.addControl("custom3", new FormControl('',Validators.required));
      this.formGroup1.get('custom3').valueChanges.subscribe(data=> this.selectedContact = data);
      this.isVisibleCustom3 = true;
    }
    else{
      this.formGroup1.removeControl('custom3');
      this.isVisibleCustom3 = false;
    }
  };

  public findContacts(searchQuery:string){
    const body: ContactPageRequestDto = {
      pageNumber: 0,
      pageSize: 50,
      filters: {
        filterType: GlobalSearchResultTypeEnum.CONTACT,
        companyId:[this.companyId],
        search:searchQuery,
      },
    };

    this.contactService.findContacts({ body }).subscribe(res=>{
      this.contacts = res.content.map(x=> <KeyValuePair>{key:x.id, value:x.name+" - "+x.title})
    });
  }

  public bookMeeting(){
    this.meetingModelToMeetingDto();

    this.dialogRef.close(this.meetingDto);
  }

  private  meetingModelToMeetingDto(){
    this.meetingDto={
      purpose: (this.findQuestions('radioGroup1').elementSelectedValue[0]=='Other (describe)')
        ?this.findQuestions('radioGroup1').elementCustomSpecify
        :this.findQuestions('radioGroup1').elementSelectedValue[0],
      target:{
        department:(this.findQuestions('radioGroup2').elementSelectedValue[0]=='Other (describe)')
          ?this.findQuestions('radioGroup2').elementCustomSpecify
          :this.findQuestions('radioGroup2').elementSelectedValue[0],
        personLevel:this.findQuestions('radioGroup3').elementSelectedValue[0],
        company:{
          id:this.companyId,
          name:this.companyName
        }
      }

    };
    if(this.findQuestions('radioGroup3').elementSelectedValue[0] === 'Specific Person (enter name)'){
      this.meetingDto.target.personId = this.selectedContact[0].key;
      this.meetingDto.target.personName = this.selectedContact[0].value;
    }

  }
  private setDataIfPerson(){
    this.findQuestions('radioGroup3').elementSelectedValue[0]='Specific Person (enter name)';

  }


}
